document.addEventListener(`DOMContentLoaded`, () => {
  
  var _galley = document.querySelectorAll(`.js-gallery_box`);
  
  for(var i=0; i<_galley.length; i++){
    var _cardLink = _galley[i].querySelectorAll(`a`);
    
    for(var j=0; j<_cardLink.length; j++){
      
        var modal = new Modal();
        
        _cardLink[j].addEventListener(`click`, (e)=>{
        e.preventDefault();
        
        var SOURCE = e.target.getAttribute(`src`);
        
        modal.open();
        modal.bgClose();
        
        var _img = document.querySelector(`.js-cardImg`);
        _img.setAttribute(`src`,SOURCE);
        
        return false;

      });
    }
  }
  
  
  
/**
* スクロール演出
*/

  controller = new ScrollMagic.Controller();
  
  //基本

  let _fadeSideIn = document.querySelectorAll(`.js-fadeSideIn`);
  let fadeSlideInLen = _fadeSideIn.length;

  let _fadeBtn = document.querySelectorAll(`.js-fadeBtn`);
  let fadeBtnLen = _fadeBtn.length;
  let xDis = deviceIsSp ? 50 : 100;

  //ボタン

  for (let i = 0; i < fadeBtnLen; i++) {
    let fadeTitle = new ScrollMagic.Scene({
        triggerElement: _fadeBtn[i],
        triggerHook: 0.8, // 開始の上下
        reverse: true,
        offset: 0, //トリガーの要素の上下
      })
      .setClassToggle(_fadeBtn[i], `is-show`)
      .addTo(controller);
  }
  
  
let fadeAndSlide = (element, dis, duration) => {
  if (element.classList.contains(`js-fadeSlideIn--fromleft`)) {
    dis *= -1;
  }

  return TweenMax.fromTo(element, duration, {
    x: dis,
    alpha: 0
  }, {
    x: 0,
    alpha: 1
  });
}
  
 for (let i = 0; i < fadeSlideInLen; i++) {
   let fadeSide = fadeAndSlide(_fadeSideIn[i], xDis, 0.2);
   let fadeTitle = new ScrollMagic.Scene({
       triggerElement: _fadeSideIn[i],
       triggerHook: 0.8, // 開始の上下
       reverse: true,
       offset: 0, //トリガーの要素の上下
     })
     .setTween(fadeSide)
     .addTo(controller);
 }
  
});

